import { lazy } from "react";
import type { RouteObject } from "react-router";

const HrIndex = lazy(() => import("./pages/page"));
const Employees = lazy(() => import("./pages/employees/page"));
const Attendance = lazy(() => import("./pages/attendance/page"));
const Departments = lazy(() => import("./pages/departments/page"));
const Designations = lazy(() => import("./pages/designations/page"));
const Holidays = lazy(() => import("./pages/holidays/page"));
const LeaveAllocations = lazy(() => import("./pages/leave-allocations/page"));
const LeaveApplications = lazy(() => import("./pages/leave-applications/page"));
const LeaveTypes = lazy(() => import("./pages/leave-types/page"));
const OvertimeRequests = lazy(() => import("./pages/overtime-requests/page"));
const SalaryStructures = lazy(() => import("./pages/salary-structures/page"));
const SalarySlips = lazy(() => import("./pages/salary-slips/page"));

// Payroll Entries
const PayrollEntries = lazy(() => import("./pages/payroll-entries/page"));
const PayrollEntryDetail = lazy(() => import("./pages/payroll-entries/[id]/page"));

// Reports
const Pnd1 = lazy(() => import("./pages/reports/pnd1/page"));
const Sps110 = lazy(() => import("./pages/reports/sps1-10/page"));
const WithholdingTax = lazy(() => import("./pages/reports/withholding-tax/page"));

export const hrRoutes: RouteObject[] = [
  { index: true, Component: HrIndex },
  { path: "employees", Component: Employees },
  { path: "attendance", Component: Attendance },
  { path: "departments", Component: Departments },
  { path: "designations", Component: Designations },
  { path: "holidays", Component: Holidays },
  { path: "leave-allocations", Component: LeaveAllocations },
  { path: "leave-applications", Component: LeaveApplications },
  { path: "leave-types", Component: LeaveTypes },
  { path: "overtime-requests", Component: OvertimeRequests },
  { path: "salary-structures", Component: SalaryStructures },
  { path: "salary-slips", Component: SalarySlips },

  // Payroll Entries
  { path: "payroll-entries", Component: PayrollEntries },
  { path: "payroll-entries/:id", Component: PayrollEntryDetail },

  // Reports
  { path: "reports/pnd1", Component: Pnd1 },
  { path: "reports/sps1-10", Component: Sps110 },
  { path: "reports/withholding-tax", Component: WithholdingTax },
];
